import { useCallback } from 'react';
import { useLocation } from 'wouter';
import { Id } from '@/convex/_generated/dataModel';

export function useContextRouting() {
  const [location, navigate] = useLocation();
  
  const navigateToContext = useCallback((contextId: Id<'contexts'>, path: string = '/inbox') => {
    navigate(`/context/${contextId}${path}`);
  }, [navigate]);
  
  const navigateInCurrentContext = useCallback((path: string) => {
    const match = location.match(/^\/context\/([^/]+)/);
    if (match) {
      const contextId = match[1];
      navigate(`/context/${contextId}${path}`);
    }
  }, [navigate, location]);
  
  const getCurrentContextId = useCallback((): Id<'contexts'> | null => {
    const match = location.match(/^\/context\/([^/]+)/);
    return match ? match[1] as Id<'contexts'> : null;
  }, [location]);
  
  const getCurrentPath = useCallback((): string => {
    const match = location.match(/^\/context\/[^/]+(.*)$/);
    return match ? match[1] || '/inbox' : '/inbox';
  }, [location]);
  
  return {
    navigateToContext,
    navigateInCurrentContext,
    getCurrentContextId,
    getCurrentPath,
    currentContextId: getCurrentContextId(),
    currentPath: getCurrentPath(),
  };
}